import { render, staticRenderFns } from "./two-col-layout.vue?vue&type=template&id=1eb8fed3&"
import script from "./two-col-layout.vue?vue&type=script&lang=js&"
export * from "./two-col-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LnCustomButton: require('/usr/src/app/components/ln-custom-button.vue').default})
